import axios from "axios";
import configuration from "./Config.json";

const hub_url = process.env.REACT_APP_API_URL;

const auth_url = process.env.REACT_APP_AUTH_URL;

//var clientId = "semplicita_catasto";
var clientId = "touristCard";
const Repo = {
  getListaPoiValidare: () => {
    var config = {
      method: "GET",
      url: hub_url + configuration.GET_LISTA_POI_VALIDARE,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  getListaPoiFiltro: (state) => {
    var config = {
      method: "GET",
      url:
        hub_url + configuration.GET_LISTA_POI_FILTRO + "?filterState=" + state,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },
  postOperatoreNewPOI: (dataPOI) => {
    var operation = {
      method: "POST",
      url: hub_url + configuration.NEW_LUOGO_INTERESSE_OPERATORE,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: dataPOI,
    };
    return axios(operation);
  },

  postUpdateSatePoi: (idPOI, stato) =>
    axios({
      method: "POST",
      url:
        hub_url +
        configuration.UPDATE_STATE_POI +
        "/" +
        idPOI +
        "/" +
        "?stato=" +
        stato,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getListaCardPerStruttura: () => {
    var config = {
      method: "GET",
      url: hub_url + configuration.COUNT_CARD_BY_STRUTTURA,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  getListaScanPerPOI: () => {
    var config = {
      method: "GET",
      url: hub_url + configuration.COUNT_CARD_BY_POI,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  postNewCard: (datacard) => {
    var operation = {
      method: "POST",
      url: hub_url + configuration.CARD_ADD,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: datacard,
    };
    return axios(operation);
  },

  getInfoCard: (idCard) => {
    var config = {
      method: "GET",
      url: hub_url + configuration.GET_INFO_CARD + "/" + idCard,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  postNewPOI: (dataPOI) => {
    var operation = {
      method: "POST",
      url: hub_url + configuration.NEW_LUOGO_INTERESSE,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: dataPOI,
    };
    return axios(operation);
  },

  getStoreLuogoInteresse: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.STORE_LUOGO_INTERESSE,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getNumeroUtenzeDisponibili: (token, idCard) =>
    axios({
      method: "GET",
      url: hub_url + configuration.NUMERO_UTENZE_DISPONIBILI + "/" + idCard,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postScanUtenze: (token, idCard, utenze) =>
    axios({
      method: "POST",
      url:
        hub_url +
        configuration.AGGIUNGI_SCAN_UTENZE +
        "/" +
        idCard +
        "/" +
        "?accessoUtenze=" +
        utenze,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  postModifyScanUtenze: (token, idScanCard, Nuoveutenze) =>
    axios({
      method: "POST",
      url:
        hub_url +
        configuration.UPDATE_ENTRATE_SCAN_CARD +
        "/" +
        idScanCard +
        "?accessoUtenze=" +
        Nuoveutenze,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getHistoryScan: (token) =>
    axios({
      method: "GET",
      url: hub_url + configuration.CRONOLOGIA_SCANSIONI,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getHistoryCard: (idStruttura) =>
    axios({
      method: "GET",
      url: hub_url + configuration.CRONOLOGIA_CARD_TOURIST + "/" + idStruttura,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getCardFilter: (cardFilter, idStruttura) =>
    axios({
      method: "POST",
      url: hub_url + configuration.GET_CARD_FILTER + "/" + idStruttura,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: cardFilter,
    }),

  getCardDownload: (idFile) =>
    axios({
      method: "GET",
      url: hub_url + configuration.GET_CARD_DOWNLOAD + "/" + idFile,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getDeleteCard: (token, idCard) =>
    axios({
      method: "GET",
      url: hub_url + configuration.CARD_DELETE + "/" + idCard,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      params: {},
    }),

  getAuthStruttura: (paramAuth) => {
    var config = {
      method: "GET",
      url: hub_url + configuration.AUTH_STRUTTURA + "?paramCipher=" + paramAuth,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  getStrutturaFromCfPiva: (cfPiva) => {
    var config = {
      method: "GET",
      url:
        hub_url +
        configuration.STRUTTURA_FROM_CFPIVA +
        "?cfPIvaUtente=" +
        cfPiva,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(config);
  },

  postRegistration: (obb) => {
    var config = {
      method: "post",
      url:
        auth_url +
        configuration.AUTH_PATH_POST_REGISTER +
        "?ClientId=" +
        clientId,
      headers: {
        "Content-Type": "application/json",
      },
      data: obb,
    };

    return axios(config);
  },

  postConfirmRegistration: (userid, code) => {
    var config = {
      method: "post",
      url:
        auth_url +
        configuration.AUTH_PATH_POST_CONFIRM_REGISTER +
        "?userid=" +
        userid +
        "&code=" +
        code,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postResetPassword: (userid, code, password) => {
    var config = {
      method: "post",
      url:
        auth_url +
        configuration.AUTH_PATH_POST_RESET_PASSWORD +
        "?userid=" +
        userid +
        "&code=" +
        code +
        "&password=" +
        password,
      headers: {
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },

  postLogin: (username, password, role) => {
    let roleSend = "";
    if (role) {
      roleSend = role;
    }

    var config = {
      method: "post",
      url:
        auth_url +
        configuration.AUTH_PATH_POST_LOGIN +
        "?username=" +
        username +
        "&password=" +
        password +
        "&role=" +
        roleSend +
        "&clientId=" +
        clientId,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  postForgotPassword: (email) => {
    var config = {
      method: "post",
      url:
        auth_url +
        configuration.AUTH_PATH_POST_FORGOT_PASSWORD +
        "?email=" +
        email +
        "&clientId=" +
        clientId,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },

  downloadManuale: () => {
    var operation = {
      method: "GET",
      url: hub_url + configuration.DOWNLOAD_MANUALE,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    return axios(operation);
  },
};

export default Repo;
